import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input";

export default class extends Controller {
    static get values() {
        return {
            hiddenInput: String,
            availableCountries: Array
        };
    }

    async connect() {
        if (!this.mobileCountryCode) {
            await import("imports/intl-tel-input-utils");
            const hiddenInput = this.element.form[this.hiddenInputValue];
            this.mobileCountryCode = intlTelInput(
                this.element,
                {
                    separateDialCode: true,
                    onlyCountries: this.availableCountriesValue,
                    initialCountry: hiddenInput.value
                }
            );
            hiddenInput.value = this.mobileCountryCode.getSelectedCountryData().iso2.toUpperCase();
            this.element.addEventListener("countrychange", () => {
                hiddenInput.value = this.mobileCountryCode.getSelectedCountryData().iso2.toUpperCase();
            });
        }
    }
}